// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TrustSignalsGroup_wrapper__tC0O1"};